<template>
  <div class="column-100">
    
    <p class="input-error-message" v-if="error_message">{{error_message}}</p>
    <label>Select State*</label>

    <select v-model="state" id=""  name="state"  :class="{'validate-error':error_message}">
      <option :value="''">Select State{{(is_required ? '*' : '')}}</option>
      <option :value="key" v-for="(state, key) in local_config.fields.state.choices" :selected="key === state">
        {{key +' - '+ local_config.fields.state.choices[key]}}
      </option>
    </select>


      
  </div>
</template>

<script>
    import {fields} from '../../mixins/requests/fields'
    import {field_component_mixin} from './field_component_mixin'

    export default {
        name: "state",
        mixins: [fields, field_component_mixin],
        data(){
            return{
                field_name: "state"
            }
        },
        computed: {

        },
        mounted() {
          if(this.$store.getters.default_state){
            this.state = this.$store.getters.default_state;
          }
        }
    }
</script>

<style scoped>
</style>